module.exports = __webpack_public_path__ + "img/upload.0f6e552f.png";